import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Are you a registered NDIS provider?",
    a: "Yes — Guiding Support Services is a registered NDIS provider compliant with the NDIS Quality and Safeguards Commission standards across Australia.",
  },
  {
    q: "Do you accept self‑managed, plan‑managed and agency‑managed participants?",
    a: "Absolutely. We support every plan‑management style and can guide you on what works best for your situation.",
  },
  {
    q: "How quickly can support start?",
    a: "After your free consultation, most participants are matched with a support worker within 5–10 business days. Urgent requests are prioritised.",
  },
  {
    q: "Can I choose my support worker?",
    a: "Yes. We carefully match you based on personality, language, cultural background and goals — and you can request a change at any time.",
  },
  {
    q: "How do you ensure quality and safety?",
    a: "Every worker is police‑checked, NDIS Worker Screening verified and continuously trained in person‑centred and trauma‑informed practice.",
  },
  {
    q: "What if my plan doesn’t cover everything I need?",
    a: "We can refer you to a Support Coordinator or advocate to help with plan reviews so you’re not paying out of pocket unnecessarily.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-brand-sand/60"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center">
          <span className="text-xs uppercase tracking-[0.22em] text-brand-terracotta font-semibold">
            Frequently asked
          </span>
          <h2 className="mt-3 font-heading font-semibold tracking-tight text-brand-forest text-3xl sm:text-4xl lg:text-5xl">
            Questions, gently answered.
          </h2>
        </div>

        <div className="mt-12 bg-white rounded-2xl border border-brand-sand p-2 md:p-4">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-brand-sand last:border-b-0"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-medium text-base md:text-lg text-brand-ink text-left hover:no-underline hover:text-brand-forest px-4"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-sm md:text-base text-brand-muted leading-relaxed px-4 pb-5"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
